export default {
    name: "GA4",

    render() {
        return
    },

    data() {
        return {
            viewTracked: false,
            completeTracked: false,

            currentQuartile: undefined,
            heartBeatCount: 0,

            durationFromMetadata: undefined,
            playReason: undefined,

            heartbeatInterval: null,
            viewTrackInterval: null,

            adBlockerDetected: false,

            trackableJWEvents: {
                'jwReady': { name: 'video_player_ready', options: { } },
                // 'jwSetupError': { name: 'video_error', options: { video_error_cm: 1 } },
                // 'jwError': { name: 'video_error', options: { video_error_cm: 1 } },
                // 'jwAdError': { name: 'adError', options: { } },
                // 'jwAdBlock': { name: 'adBlock', options: { } },
                // 'jwAdRequest': { name: 'adRequest', options: { } },
                // 'jwAdImpression': { name: 'video_playAd', options: { video_playAd_cm: 1 } },
                // 'jwAdPlay': { name: 'adPlay', options: { } },
                // 'jwAdPause': { name: 'adPause' },
                // 'jwAdComplete': { name: 'adComplete', options: { } },
                // 'jwAdClick': { name: 'adClick' },
                // 'jwAdMeta': { name: 'adMeta', options: { } },
                // 'jwPlayAttempt': { name: 'playAttempt', options: { } },
                // 'jwBeforePlay': { name: 'beforePlay', options: { } },
                // 'jwPlay': { name: 'play' },
                // 'jwBuffer': { name: 'buffer', options: { } },
                // 'jwBufferChange': { name: 'bufferChange', options: { } },
                // 'jwBufferFull': { name: 'bufferFull', options: { } },
                // 'jwFirstFrame': { name: 'view', options: { } },
                // 'jwPause': { name: 'pause' },
                // 'jwBeforeComplete': { name: 'beforeComplete', options: { } },
                // 'jwComplete': { name: 'complete', options: { } },
                // 'jwPlaylistComplete': { name: 'playlistComplete', options: { } },
                // 'jwMute': { name: 'mute' },
                // 'jwFullscreen': { name: 'fullscreen' },
                // 'jwResize': { name: 'resize' },
                // 'jwSeek': { name: 'seek' },
                // 'jwSeeked': { name: 'seeked', options: { } },
                // 'jwMeta': { name: 'meta', options: { } },
                // 'jwTime': { name: 'time', options: { } },
                // 'jwPlaylist': { name: 'playlist' },
                // 'jwPlaylistItem': { name: 'playlistItem' },
                // 'jwProviderChanged': { name: 'providerChanged' },
                // 'jwLevels': { name: 'levels' },
            },
            trackableHomadEvents: {
                // 'hdPenalty': { 'name': 'homadPenalty', options: {} }, // penalty function has been called, due to blocked functionality
                // 'hdVpaid': { 'name': 'homadVpaid', options: {} }, // HOMAD recieved a VPAID response
                // 'hdContinueContent': { 'name': 'homadContinueContent', options: {} }, // resume content video
                // 'hdContentPlayerPlay': { 'name': 'homadContentPlayerPlay', options: {} }, // HOMAD called play on content player
                // 'hdContentPlayerPause': { 'name': 'homadContentPlayerPause', options: {} }, // HOMAD called pause on content player
                // 'hdAdSkipped': { 'name': 'adSkipped', options: {} }, // ad has been skipped
                // 'hdAdRequest': { 'name': 'adRequest', options: {} }, // ad is requested by the player
                // 'hdAdError': { 'name': 'adError', options: {} },
                // 'hdAdImpression': { 'name': 'video_playAd', options: {} }, // HOMAD ad delivery impressions called
                // 'hdAdStart': { 'name': 'adStart', options: {} }, // HOMAD ad delivery started
                // 'hdAdTime': { 'name': 'adTime', options: {} }, // ad playback is in progress
                // 'hdAdFirstQuartile': { 'name': 'adFirstQuartile', options: {} }, // HOMAD ad delivery first quartile
                // 'hdAdMidPoint': { 'name': 'adMidPoint', options: {} }, // HOMAD ad delivery mid point reached
                // 'hdAdThirdQuartile': { 'name': 'adThirdQuartile', options: {} }, // HOMAD ad delivery third quartile
                // 'hdAdComplete': { 'name': 'adComplete', options: {} }, // HOMAD ad delivery completed
                // 'hdAdPlay': { 'name': 'adPlay', options: {} }, // ad is played
                // 'hdAdPause': { 'name': 'adPause', options: {} }, // ad is paused
                // 'hdAdClick': { 'name': 'adClick', options: {} }, // HOMAD detected click on ad video
            },
        }
    },

    mounted() {
        this.$l.log('[GA4] mounted', this.$settings.googleAnalytics)
        this.setupEventListeners()
        this.setupHeartBeat()
    },

    watch: {
        currentQuartile(newQuartile, oldQuartile) {
            this.$l.log('[GA4] currentQuartile', oldQuartile, newQuartile)
            if(newQuartile) {
                this.track('video_quartile_view', {quartile: newQuartile})
            }
        }
    },

    computed: {
        duration() {
            return this.durationFromMetadata || this.$item.duration;
        },

        start_type() {
            switch(this.playReason) {
                case "interaction":
                case "related-interaction":
                    return "manual"

                case "autostart":
                case "viewable":
                case "related-auto":
                case "playlist":
                case "external": // API usage
                    return "autoplay"

                case "unknown":
                    return "unknown"
            }

            return undefined
        },

        reco() {
            switch(this.playReason) {
                case "related-auto":
                case "related-interaction":
                case "playlist":
                    return "revolver-play"

                default:
                    return undefined
            }
        },

        genericEventParams() {

            var embedLocation = (this.$helpers.inIframe()) ? document.referrer : location.href;

            var onlineSinceDate = undefined;
            var onlineSinceParts = [undefined,undefined];
            var onlineSinceTS = undefined;

            var onlineSince = this.$item.validFrom || this.$item.createdAt;

            if(onlineSince) {
                onlineSinceDate = this.$helpers.parseDate(onlineSince);
                onlineSinceParts = onlineSince.split(" ");

                if(onlineSinceDate) {
                    onlineSinceTS = Math.floor(onlineSinceDate / 1000);
                }

                if(isNaN(onlineSinceTS)) {
                    onlineSinceTS = undefined
                }
            }

            let data = {
                video_id: String(this.$item.id),
                video_list_id: String(this.$item.playlistId),
                title: String(this.$item.title),
                format_id: String(this.$item.formatId),
                format: String(this.$item.format),
                bo_nummer: String(this.$item.boNr),
                part: undefined, //sequenceNumber?
                online_since_date: String(onlineSinceParts[0]), //Gültig Ab Datum aus Isy, wenn vorhanden, sonst Publikationsdatum an BOBY-Connect (TBD mit IT); Format „YYYY-MM-DD“
                online_since_time: String(onlineSinceParts[1]),
                online_since_ts: String(onlineSinceTS),
                product: this.$helpers.stripDomain(embedLocation),
                start_type: this.start_type, //„manual“ = User drückt manuell auf Play-Button für Video-Start, „autoplay“ = Video wird automatisch gestartet
                reco: this.reco, //„hola-spark“, „outbrain“ etc., wenn Video über Recommendation-Engine aufgerufen wurde
                video_length: String(this.duration), // why HH:MM:SS ?
                video_length_seconds: String(this.duration), // why HH:MM:SS ?
                fsk: String(this.$item.ageRating),
                content_form: this.duration ? (this.duration >= 480 ? "long" : "short") : undefined, //„short“ alles unter 8 Minuten, „long“ alles drüber
                content_type: undefined, //Neues Feld Isy, z.B. “Klammerteil“, „Highlights“, „Ganze Folge“, „Trailer“ etc.
                adblocker_active: String(this.adBlockerDetected),
                tracking_concept_version: this.$settings.ga4.trackingConceptVersion || 'dev-undefined',
                tracking_product_version: this.$settings.ga4.trackingProductVersion + "-" + this.$settings.environment || 'dev-undefined',
                url: embedLocation,
                content_type: String(this.$item.videoType),
                content_effective_date: String(this.$item.timeOfPublication),
                content_perspective: String(this.$item.perspective),
                content_materialtype: String(this.$item.materialType)
            }

            // some null values from isy are converted to String "null" - lets undo that here:
            Object.keys(data).forEach(function(key){
                data[key] = data[key] == "null" ? undefined : data[key]
                data[key] = data[key] == "undefined" ? undefined : data[key]
            });

            return data;

        }
    },

    methods: {

        reset() {
            this.viewTracked = false;
            this.completeTracked = false;

            this.currentQuartile = undefined;
            this.heartBeatCount = 0;

            this.durationFromMetadata = undefined;
            this.playReason = undefined;

            clearInterval(this.viewTrackInterval);
            clearInterval(this.heartbeatInterval);
            this.setupHeartBeat()
        },

        setupEventListeners() {
            this.$events.on(Object.keys(this.trackableJWEvents), this.onTrackableJWEvent)
            this.$events.on(Object.keys(this.trackableHomadEvents), this.onTrackableHomadEvent)

            this.$events.$on(['jwPlay','jwBeforePlay','jwPlayAttempt'],this.extractPlayReason)

            // this.$events.on(Object.keys(this.trackableHomadEvents), this.onHomadEvent)
        },

        onTrackableJWEvent(evt) {

            if (typeof(evt.type) != 'undefined') {
                evt.eventName = 'jw' + evt.type[0].toUpperCase() + evt.type.substring(1)
                evt.event = this.trackableJWEvents[evt.eventName] || {}
                evt.eventOptions = evt.event.options || {}
            }

            if(this.$jwplayer.getAdBlock()) {
                this.adBlockerDetected = true;
            }

            this.$l.log('[GA4] onJWEvent |', evt.eventName, evt.type, evt)
            // this.setupEventSpecificCustomDimensions(evt)
            this.track(evt.event.name, evt.eventOptions)
        },

        onTrackableHomadEvent(evt) {

            if (typeof(evt.type) != 'undefined') {
                evt.eventName = 'hd' + evt.name[0].toUpperCase() + evt.name.substring(1)
                evt.event = this.trackableHomadEvents[evt.eventName] || {}
                evt.eventOptions = evt.event.options || {}
            }

            this.adBlockerDetected = true;

            this.$l.log('[GA4] onHomadEvent', evt.eventName, evt.name, evt)
            // this.setupEventSpecificCustomDimensions(evt)
            this.track(evt.event.name, evt.eventOptions)
        },

        track(eventName, eventOptions = {}) {

            let options = {};

            // switch(eventName) {
            //     case 'heartbeat':
            //         options = {
            //             quartile: this.currentQuartile
            //         }
            //         break;
            // }

            this.$helpers.assign(options, eventOptions, this.genericEventParams)

            this.$l.log('[GA4] track |', eventName, options)

            window.parent.postMessage({
                action: 'ga4_player_event',
                eventName: eventName,
                eventOptions: options
            }, '*');
        },

        setupHeartBeat() {
            this.heartbeatInterval = setInterval(this.heartBeat, 1000);
        },

        heartBeat() {
            if(this.$jwcomp && this.$jwcomp.state == 'playing' && this.$jwcomp.adState != 'playing') {
                this.heartBeatCount++

                if( this.heartBeatCount % this.$settings.ga4.heartBeatSeconds == 0 ) {
                    this.$l.log('tracking heartBeat', this.heartBeatCount)
                    this.track('video_heartbeat', {
                        // nonInteraction: true,
                        watched_seconds_cm: this.$settings.ga4.heartBeatSeconds,
                        quartile: this.currentQuartile ? String(this.currentQuartile) : undefined
                    })
                }
            }
        },

        extractPlayReason(playEvent) {
            if(playEvent && playEvent.playReason) {
                this.playReason = playEvent.playReason;
            }
        },


    },

    events: {

        newItemData(evt) {
            // new video data = new view
            this.$l.log('[GA4] newItemData')
            this.reset();
        },

        jwMeta(evt) {

            this.$l.log('[GA4] jwMeta |', evt);

            if(evt.duration) {
                this.durationFromMetadata = Math.floor(evt.duration)
            }
        },

        jwTime(evt) {
            // this.$l.log('[GA4] jwTime |', evt);

            if(evt.duration && evt.currentTime) {
                var percentage = evt.currentTime / evt.duration;;
                var quartile = Math.ceil( percentage / 0.25 );

                if(quartile < 1) quartile = 1;
                if(quartile > 4) quartile = 4;

                this.currentQuartile = quartile;

                if(!this.completeTracked && percentage >= 0.9) {
                    var vm = this;
                    setTimeout(function() {
                        vm.track('video_completed', {
                            video_complete_cm: 1
                        })
                    }, 500)
                    this.completeTracked = true;
                }
            }
            else {
                this.currentQuartile = undefined;
            }
        },

        jwSetupError(evt) {
            this.track('video_error', {
                type: 'setup-error',
                message: evt.message,
                video_error_cm: 1
            })
        },

        jwError(evt) {
            this.track('video_error', {
                type: 'playback-error',
                message: evt.code + ': ' + evt.message,
                video_error_cm: 1
            })
        },

        jwFirstFrame(evt) {
            if(this.viewTracked) return;
            var vm = this;
            if(!vm.viewTracked && vm.$jwcomp && vm.$jwcomp.state == 'playing' && vm.$jwcomp.adState != 'playing') {
                vm.track('video_view', {
                    video_view_cm: 1
                })
                vm.viewTracked = true;
                // clearInterval(vm.viewTrackInterval);
            }

            // clearInterval(this.viewTrackInterval);
            // if(this.viewTracked) return;
            // var vm = this;
            //
            // this.viewTrackInterval = setInterval(function() {
            //     if(!vm.viewTracked && vm.$jwcomp && vm.$jwcomp.state == 'playing' && vm.$jwcomp.adState != 'playing') {
            //         vm.track('video_view', {
            //             video_view_cm: 1
            //         })
            //         vm.viewTracked = true;
            //         clearInterval(vm.viewTrackInterval);
            //     }
            // }, 1000);
        },

        jwAdImpression(evt) {
            this.$l.log('[GA4] jwAdImpression',evt.adschedule.breakid);
            this.track('video_playAd', {
                ad_type: evt.adschedule.breakid.replace('roll',''),
                video_playAd_cm: 1
            })
        },

        hdAdImpression(evt) {
            this.$l.log('[GA4] hdAdImpression',evt.state);

            this.adBlockerDetected = true;

            this.track('video_playAd', {
                ad_type: evt.state.replace('roll',''),
                video_playAd_cm: 1
            })
        },

    }
}



// WEBPACK FOOTER //
// ./src/components/tracking/ga4.js